import AsyncStorage from "@react-native-async-storage/async-storage"
import { ACTIVITIES_DEMO_DATA_URL, activityPath, DEMO_FLOW_ENABLED } from "../../config/Constant";
import { getCleanUrl } from "../../utils/Helper";

export const fetchBookings = (callback=()=>{}) => {
    return async (dispatch, getState) => {
        const sessionToken = await AsyncStorage.getItem('sessionToken');
        
        try {
            if(DEMO_FLOW_ENABLED){
                const response = await fetch(
                    getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/fetchBooking.json`)
                );

                const json = await response.json();

                callback(true, json.payload?.Data?.items);
                return
            }
            const response = await activityPath.post("/fetchBookings", {
                header: {
                    sessionToken
                },
                payload: {

                }
            })
            callback(true, response?.data?.payload?.Data?.items)
        } catch (error) {
            const errMessage = error?.response?.header?.status?.msg || error?.message || "Something Went wrong"
            callback(false, errMessage)
        }
    }
    
}

export const getEvents = (categoryIds, callback=()=>{})=>{
    return async (dispatch, getState) => {
        try {
            if(DEMO_FLOW_ENABLED){
                const response = await fetch(
                    getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getEvents.json`)
                );

                const json = await response.json();
                callback(true, json?.payload?.data)
                return
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const guestToken = await AsyncStorage.getItem("guestToken");
            const payload = {}
            if(categoryIds){
                payload.categoryIds = categoryIds
            }

            const response = await activityPath.post("/getEvents", {
                header: {
                    sessionToken: sessionToken,
                    guestToken: guestToken
                },
                payload: payload
            })

            if(response.data?.header?.status?.code == "SUCCESS" && !categoryIds){
                callback(true, response.data?.payload?.data)
            } else {
                callback(false, "Something went wrong")
            }
            
        } catch (error) {
            let errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage)
        }
    }
}


export const getEventsInfo = (listingId, kind)=>{
    return async (dispatch, getState) => {
        try {
            if(DEMO_FLOW_ENABLED){
                if(kind === "experience"){
                    const response = await fetch(
                        getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getEventsInfoExperience.json`)
                    );

                    const json = await response.json();

                    return { eventInfo: json?.payload.data };
                } else if ( kind === "resource" ) {
                    const response = await fetch(
                        getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getEventsInfoSubEvents.json`)
                    );

                    const json = await response.json();

                    return { eventInfo: json?.payload.data };
                } else {
                    const response = await fetch(
                        getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getEventsInfoEvent.json`)
                    );

                    const json = await response.json();
                    return { eventInfo: json?.payload.data };
                }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');

            const response = await activityPath.post("/getEventsInfo", {
                header: {
                    sessionToken: sessionToken
                },
                payload: {
                    listingId
                }
            })

            if(response.data?.header?.status?.code == "SUCCESS"){
                return {eventInfo: response.data?.payload?.data}
            }
            
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }
        }
    }
}

export const getAvailbility = (experienceId, experienceIdsList, callback=()=>{}, kind)=>{
    return async (dispatch, getState) => {
        try {
            if(DEMO_FLOW_ENABLED){
                if(kind === "experience"){
                    const response = await fetch(
                        getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getAvailabilityExperience.json`)
                    );

                    const json = await response.json();

                    callback(true, json?.payload.data);
                } else if ( kind === "resource" ) {
                    const response = await fetch(
                        getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getAvailabilitySubEvents.json`)
                    );

                    const json = await response.json();

                    callback(true, json?.payload.data);
                } else {
                    const response = await fetch(
                        getCleanUrl(`${ACTIVITIES_DEMO_DATA_URL}/getAvailabilityEvent.json`)
                    );

                    const json = await response.json();

                    callback(true, json?.payload.data);
                }
                return
            }

            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const payload_ = {}
            if(experienceId) payload_.experienceId = experienceId
            if(experienceIdsList) payload_.experienceIdsList = experienceIdsList

            const response = await activityPath.post("/getAvailbility", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            })

            if(response.data?.header?.status?.code == "SUCCESS"){
                callback(true, response.data?.payload?.data)
            } else {
                callback(false, response.data?.header?.status.msg);
            }
            
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            callback(false, errorMessage);
        }
    }
}


export const createWayBooking = (payload_) => {
    return async (dispatch, getState) => {
        try {
            if(DEMO_FLOW_ENABLED){
                return { data: { bookingId: "ThisIsDemo" } }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');

            const response = await activityPath.post("/createBooking", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            });

            return { data: response?.data?.payload?.data };
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }
        }

    }
}

export const cancelWayBooking = (payload_) => {
    return async (dispatch, getState) => {
        
        try {
            if(DEMO_FLOW_ENABLED){
                return { data: "Booking cancelled successfully" }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');
    
            const response = await activityPath.post("/cancel", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            })
            return { status: true, data: response?.data?.header?.status?.msg };

        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { error: errorMessage }
        }
    }
}

export const updateMyWayBooking = (payload_) => {
    return async (dispatch, getState) => {
        
        try {
            if(DEMO_FLOW_ENABLED){
                return { data: "Booking updated successfully" }
            }
            const sessionToken = await AsyncStorage.getItem('sessionToken');
        
            const response = await activityPath.post("/booking/reschedule", {
                header: {
                    sessionToken: sessionToken
                },
                payload: payload_
            })

            return { status: true, data: response?.data?.header?.status?.msg };
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error.message || "Something went wrong";
            return { status: false, error: errorMessage }  
        }
    }
}